export const ingredients = [
  {
    id: 'main',
    items: [
      {
        name: 'Vegetable oil',
        number: 0.3,
        unit: 'cup',
        numberMetric: 85,
        unitMetric: 'g',
        note: 'plus 3 Tbsp extra'
      },
      {
        name: 'Yellow onion',
        preparation: 'finely diced',
        number: 0.5,
        unit: 'cup',
        numberMetric: 75,
        unitMetric: 'g',
        note: 'about 0.5 medium onion'
      },
      {
        name: 'Kosher salt (Diamond Crystal)',
        number: 1.25,
        unit: 'tsp',
        note: 'plus more to taste'
      },
      {
        name: 'Baking soda',
        number: 0.125,
        unit: 'tsp'
      },
      {
        name: 'Black pepper',
        preparation: 'freshly ground',
        number: 0.5,
        unit: 'tsp'
      },
      {
        name: 'Aleppo pepper',
        number: 0.5,
        unit: 'tsp'
      },
      {
        name: 'Pinto beans',
        preparation: 'drained & rinsed',
        number: 2,
        unit: '15.5oz cans',
        numberMetric: 2,
        unitMetric: '439g cans'
      },
      {
        name: 'Fresh cilantro',
        preparation: 'coarsely chopped',
        number: 2,
        unit: 'Tbsp',
      },
      {
        name: 'Fresh parsley',
        preparation: 'coarsely chopped',
        number: 2,
        unit: 'Tbsp',
      },
      {
        name: 'Fresh dill',
        preparation: 'coarsely chopped',
        number: 2,
        unit: 'Tbsp',
      },
      {
        name: "Lavash",
        number: 5,
        unit: 'sheets',
        note: 'roughly 1lb (453g)'
      }
    ]
  },
  {
    id: 'herb-sauce',
    name: 'Herb sauce',
    items: [
      {
        name: 'Fresh cilantro',
        preparation: 'coarsely chopped',
        number: 1,
        unit: 'cup',
        
      },
      {
        name: 'Fresh parsley',
        preparation: 'coarsely chopped',
        number: 1,
        unit: 'cup',
        
      },
      {
        name: 'Extra virgin olive oil',
        number: 0.75,
        unit: 'cups',
        numberMetric: 180,
        unitMetric: 'ml', 
      },
      {
        name: 'Fresh dill',
        preparation: 'coarsely chopped',
        number: 0.25,
        unit: 'cup',
        numberMetric: 16,
        unitMetric: 'g',
        
      },
      {
        name: 'Lemon juice',
        number: 2,
        unit: 'Tbsp',
        numberMetric: 30,
        unitMetric: 'ml'
      },
      {
        name: 'Garlic cloves',
        number: 2,
        unit: 'medium'
      },
      {
        name: 'Aleppo pepper',
        number: 1,
        unit: 'tsp'
      },
      {
        name: 'Kosher salt',
        number: 1,
        unit: 'tsp'
      },
      {
        name: 'Ground cumin',
        number: 0.5,
        unit: 'tsp'
      },
    ]
  }
]